import { usePrefetch } from '@/hooks/use-prefetch'
import { GetEmpreendimentosService } from '@/http/get-empreendimentos.service'
import { empreendimentosKeys } from '@/utils/empreendimento-query-keys'

export const usePrefetchEmpreendimentos = () => {
  return usePrefetch({
    queryKey: empreendimentosKeys.lista({}),
    queryFn: () => new GetEmpreendimentosService().execute({}).then((response) => response.data),
    staleTime: 60 * 1000 * 5,
  })
}
